import { UserSettingsKeys } from "constants/user-settings-keys";
import { useGlobalState } from "utilities/contexts/use-global-state-context";
import useFeatureFlags from "utilities/hooks/use-feature-flags";

interface AiChatEnabledResult {
    /** Indicates the feature flag is enabled and the user has accepted the ToS */
    enableAIChat: boolean;

    /** Indicates if the AI Chat feature flag is enabled */
    useAIChat: boolean;
}

/**
 * Custom hook that determines if AI Chat is enabled based on feature flags and user settings
 */
const useAiChatEnabled = (): AiChatEnabledResult => {
    const { useAIChat } = useFeatureFlags();
    const { globalState } = useGlobalState();

    const enableAiChatSetting: boolean =
        globalState.getUserSettingValue(UserSettingsKeys.EnableAIChat) ?? false;

    return {
        enableAIChat: useAIChat && enableAiChatSetting,
        useAIChat,
    };
};

export default useAiChatEnabled;
